import { Component, OnInit } from '@angular/core';
import { DynamicInputComponent, MenuGroup } from '../dynamic-input-model';
import { NbMenuItem, NbMenuService } from '@nebular/theme';
import { EditorService } from '../services/editor.service';
import { ThemeInputComponent } from './theme-input/theme-input.component';

@Component({
  selector: 'kve-theme-editor',
  templateUrl: './theme-editor.component.html',
  styleUrls: ['./theme-editor.component.scss']
})
export class ThemeEditorComponent implements OnInit {
  inputComponent = new DynamicInputComponent(ThemeInputComponent);

  menuGroups:any;

  title = "Editing Site Theme";
  menuTag = "editSiteThemeMenu";
  menuGroup:MenuGroup = {
    title:"Editing Site Theme",
    menuTag:"editSiteThemeMenu",
    menuItems:[
      {
        title:"Colours"
      },
      {
        title:"Typography"
      } 
    ]
  }
  menuItems:NbMenuItem[] = [
    {
      title:"Colours"
    },
    {
      title:"Typography"
    } 
  ]
  previousMenu:NbMenuItem[] = [];

  constructor(
    private editorService:EditorService,
    private menuService:NbMenuService
  
  ) { }

  ngOnInit(): void {
    this.menuGroups = this.editorService.createMenusFromGroup(this.menuGroup);
    this.inputComponent.data = this.menuGroups;
    this.editorService.setInputComponent(this.inputComponent);
    console.log(this.menuGroups);
    this.menuService.onItemClick().subscribe(menuBag =>{
      console.log({menuBag:menuBag});
      let selectedItem = menuBag.item;
      if(selectedItem != undefined){
        //if(selectedItem.parent.title)
        this.setMenu(selectedItem);
        console.log({selectedItem:selectedItem});
      }
    })
  }

  setMenu(selectedItem:NbMenuItem){
    if(selectedItem.title == "Back"){
      this.menuItems = this.previousMenu;
    }else{
      this.menuGroup.menuItems.forEach(menuItem => {
        if(menuItem.title == selectedItem.title && menuItem.children != null){
          this.previousMenu = this.menuItems;
          console.log(menuItem.title);
          let backLinkLNbMenuItem = {title:"Back",icon:"arrow-back-outline"};
          let headerItem:NbMenuItem = {title:menuItem.title,group:true}
          this.menuItems = [backLinkLNbMenuItem,headerItem].concat(menuItem.children);
        }
      })
    }
    
  }

}
